<div class="tile__status tile__status--default" data-testid="tile">
    <div class="tile__svg--other-wrapper bg-img">
        <img class="tile__svg--other"
             ngSrc="{{icon.setIcon(tile.params.iconId)}}"
             width="50" height="50" alt="" />
    </div>
    <div class="tile__subtitle tile__subtitle--flex">
        <floating-subtitle class="tile__subtitle-row"
                           [text]="subtitle(tile.params.headerId)">
        </floating-subtitle>
        <floating-subtitle [position]="'right'"
                           class="font-bold font-15 tile__subtitle-row tile__subtitle-row--right"
                           [text]="subtitle(tile.params.statusId)">
        </floating-subtitle>
    </div>
    <div class="tile__setting cursor-pointer"
        [ngClass]="{ 'bg-light-shadow': tile.elementMenu.duringChange === 't' }"
         *ngIf="tile.elementMenu && tile.menuId !== 0"
         (click)="goControl()">
        <img ngSrc="/assets/img/icons/{{ getIconName() }}.svg"
             width="30" height="30" alt="" />
        <p class="tile__setting-alert font-12 color-light"
           *ngIf="tile.elementMenu.duringChange === 't'">
           {{ subtitle(3162) }}
        </p>
    </div>
    <div class="hover-area hover-area--full-width"
         (click)="goControl()"
         [ngClass]="{ 'cursor-pointer': tile.elementMenu && tile.menuId !== 0 }"
         *ngIf="tile.params.options.length">
    </div>
    <div class="hover hover--full-width bg-dark-shadow box-shadow"
        *ngIf="tile.params.options.length">
        <p class="color-light font-12"
           *ngFor="let item of tile.params.options">
           {{ subtitle(item) }}
        </p>
    </div>
</div>
